// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".c9625dea5fdf54bcc24467c14164fa4c.js";
};